import React, { useCallback, useEffect, useState } from "react";
import KubuSpinner from "../components/spinner/KubuSpinner";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import cr from "../lib/request";
import { Cookies } from "typescript-cookie";

type Props = {
  children: any;
};

export default function RequireAuth({ children }: Props) {
  const [page, setPage] = useState(<KubuSpinner />);

  const navigate = useNavigate();
  const toast = useToast();

  const onSignout = useCallback(() => {
    const url = `api/usercourse/logout`;
    cr.post(url)
      .then((r) => {
        navigate("/");
      })
      .catch((e) => {
        console.log(e);
      });
  }, [navigate]);

  useEffect(() => {
    setPage(<KubuSpinner />);

    const url = "api/logindata";
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          console.log(r.data.data);
          Cookies.set("user", JSON.stringify(r.data.data));
          setPage(children);
        }
      })
      .catch((error) => {
        Cookies.remove("user");
        onSignout();
        console.log(error);
        toast({
          title: "Tidak Ada Akses",
          description: "Silahkan masuk terlebih dahulu",
          status: "error",
          duration: 10000,
          isClosable: true,
        });
        navigate("/");
      });
  }, [children, navigate, toast, onSignout]);

  return page;
}
